import { propmtCodesActionTypes } from '../constants/ApiConstants';

const initialState = {
  masterData: null,
  promptCodeList: null,
  promptCodeDetail: null,
  saved_promptCode: null,
  deleted_promptCode: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case propmtCodesActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case propmtCodesActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
  case propmtCodesActionTypes.save_propmtCodes.REQUEST:
    return {
      ...state,
      loading: true,
      saved_promptCode: null,
    };
  case propmtCodesActionTypes.save_propmtCodes.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_promptCode: payload,
    };
  case propmtCodesActionTypes.get_propmtCodesList.REQUEST:
    return {
      ...state,
      loading: true,
      promptCodeList: null,
    };
  case propmtCodesActionTypes.get_propmtCodesList.SUCCESS:
    return {
      ...state,
      loading: false,
      promptCodeList: payload,
    };
  case propmtCodesActionTypes.get_propmtCodesDetail.REQUEST:
    return {
      ...state,
      loading: true,
      promptCodeDetail: null,
    };
  case propmtCodesActionTypes.get_propmtCodesDetail.SUCCESS:
    return {
      ...state,
      loading: false,
      promptCodeDetail: payload,
    };
  case propmtCodesActionTypes.delete_propmtCodes.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_promptCode: null,
    };
  case propmtCodesActionTypes.delete_propmtCodes.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_promptCode: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/promptCodes/reducers/PropmtCodeReducer.js